import type { LowercaseLetter } from "@/components/shared/FilterLetters/filterLetters.types";
import type { BreedListBySpecies } from "@/domain/Breeds/breeds.types";

export const useBreedFilterLetters = (filters: BreedListBySpecies) => {
  const breedLetters = filters.map((breed) =>
    breed.name.charAt(0).toLocaleLowerCase()
  ) as LowercaseLetter[];

  const filterRepeatedLetters = () => {
    return Array.from(new Set(breedLetters));
  };

  const filterLetters = filterRepeatedLetters();

  const getUniqueAndSortedLetters = () => {
    return Array.from(new Set(filterLetters)).sort((a, b) =>
      a.localeCompare(b)
    );
  };

  const uniqueBreedLetters = getUniqueAndSortedLetters();

  const handleLetterClick = (letter: LowercaseLetter) => {
    const breedCardElement = document.getElementById(`breed-${letter}`);
    if (breedCardElement) {
      const targetPosition =
        breedCardElement.getBoundingClientRect().top + window.scrollY;

      const scrollYOffset = 150;

      const scrollToTop = targetPosition - scrollYOffset;

      window.scrollTo({
        top: scrollToTop,
        behavior: "smooth"
      });
    }
  };

  return {
    uniqueBreedLetters,
    handleLetterClick
  };
};
